module.exports = __webpack_public_path__ + "img/gsfl.7962714a.png";